import { render, staticRenderFns } from "./FrsZonesTotalSum.vue?vue&type=template&id=b44d459a&scoped=true&lang=html&"
import script from "./FrsZonesTotalSum.vue?vue&type=script&lang=js&"
export * from "./FrsZonesTotalSum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44d459a",
  null
  
)

export default component.exports